"use client";
import { useState } from "react";

export default function EntertainmentShare({ url, title }) {
  const [message, setMessage] = useState("");
  async function copy() {
    try { await navigator.clipboard.writeText(url); setMessage("Article link copied."); }
    catch { setMessage("Copy the article address from your browser to share it."); }
  }
  return <div className="ent-share"><a aria-label="Share on Facebook" href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer">f</a><a aria-label="Share on X" href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`} target="_blank" rel="noopener noreferrer">X</a><button type="button" onClick={copy} aria-label="Copy article link">↗</button><span role="status">{message}</span></div>;
}
